import { OrderPaymentPlanDeal } from 'pages/payment_deals/payment_plans/create';
import { OrderPaymentPlanShow } from 'pages/payment_deals/payment_plans';
import { OrderPaymentPlansList } from 'pages/payment_deals/payment_plans/list';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'payment_plans',
  label: 'Busca',
  list: OrderPaymentPlansList,
  show: OrderPaymentPlanShow,
  create: OrderPaymentPlanDeal,
  actions: ['list', 'show', 'create', 'deal', 'cancel', 'interrupt'],
  parentName: 'payment_deals'
};

export default generateResources(resource);
